import { Component, OnInit } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
// import { ListalicenciasService } from 'src/app/services/solicitante/listalicencias.service';
// import { Licencia } from '../../models/licencia';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {


  constructor(

    config: NgbCarouselConfig
    ) {
     // customize default values of carousels used by this component tree
     config.interval = 5000;
     config.wrap = true;
     config.keyboard = false;
     config.pauseOnHover = false;
   }

  ngOnInit() {



  }

}
